
import { Component, Vue } from "vue-property-decorator";
import GeneralFooter from "@/components/general-footer.vue";
import { Mutation, Getter } from "vuex-class";
import { SinglePagePayload } from "@/store/mutations";
import { FormValues } from "@/interfaces/FormValues";
import { DESIGN_ROUTE_NAME } from "@/router";
import { PAGE_NAMES } from "@/constants/form-page-names";
import { GENERAL_FIELD_NAMES } from "@/constants/form-field-names";

@Component({
  components: {
    GeneralFooter,
  },
})
export default class Allgemein extends Vue {
  public form_values: FormValues = {};
  public minDate = this.getMinDateAsString();
  public dateToday = this.getDateTodayAsString();

  @Getter("allFormValues")
  allFormValues!: Record<string, FormValues>;

  @Mutation("setFormValues")
  setFormValues!: (payload: SinglePagePayload) => void;

  @Getter("bankName")
  bankNameGetter!: string;

  get deliveryDate(): string {
    return (this.form_values[this.FIELD_NAMES.deliveryDate] as string) || "";
  }

  FIELD_NAMES = GENERAL_FIELD_NAMES;

  mounted() {
    // load from store or set default values
    this.form_values = this.allFormValues[PAGE_NAMES.general] || {
      [this.FIELD_NAMES.cooperative]: this.bankNameGetter,
      [this.FIELD_NAMES.previewDesired]: true,
      [this.FIELD_NAMES.deliveryDate]: this.minDate,
    };
  }

  public getDateTodayAsString(): string {
    const now = new Date();

    now.setDate(now.getDate());

    return now.toISOString().slice(0, 10);
  }

  public getMinDateAsString(): string {
    const now = new Date();

    const day = now.getDay();

    let workingDays = 2;

    switch (day) {
      case 4: // Thursday
        workingDays += 2;
        break;
      case 5: // Friday
        workingDays += 2;
        break;
      case 6: // Saturday
        workingDays += 1;
        break;
      default:
        break;
    }

    now.setDate(now.getDate() + workingDays);

    return now.toISOString().slice(0, 10);
  }

  public prev(): void {
    this.$router.go(-1);
  }

  public next(): void {
    this.$router.push({ name: DESIGN_ROUTE_NAME });
  }

  public submit(): void {
    if (this.deliveryDate < this.minDate) {
      this.$fire({
        title: "Achtung",
        html: "</br>Zwischen Auftragseingang und Liefertermin sollten mindestens 48 Stunden liegen.</br></br>",
        confirmButtonText: "OK",
      });
    }

    const payload: SinglePagePayload = {
      PAGE_NAME: PAGE_NAMES.general,
      formValues: this.form_values,
    };

    this.setFormValues(payload);

    this.next();
  }
}
